<template>
  <v-row
    justify="center"
    align="center"
  >
    <h1 class="text-center align-self-center">  App Maria Bailarina </h1>
  </v-row>
</template>

<script>
export default {
    name: 'Home',
    data () {
      return {

      }
    }
  
}
</script>

<style>

  .home {
    align-self: center!important;
  }

</style>


// WEBPACK FOOTER //
// src/views/Comum/Home.vue